/// <reference path="../../../../../../typings/globals/angular-route/index.d.ts" />
/// <reference path="../../../../../../typings/globals/angular/index.d.ts" />
/// <reference path="../../../../../../typings/globals/jquery/index.d.ts" />
/// <reference path="../../../../../../typings/globals/lodash/index.d.ts" />
/// <reference path="../../ekh/services/brandedFareTypes.service.ts" />

'use strict';


namespace Core {

    class BrandedFare {
        onSelect: (any) => void;
        fare: ekh.IBrandedFareType;
        classNameIn: string;
        classNameOut: string;
        selectButtonLabel: string;
        selectedButtonLabel: string;
        selectedFareTotalPrice: number;
        currency: string;
        pieceConceptLegIn: boolean;
        pieceConceptLegOut: boolean;

        constructor (
            private brandedFareTypesService: ekh.BrandedFareTypesService,
            private resourceService: Core.ResourceService,
            private $filter: ng.IFilterService
        ) {

        }

        $onInit() {
            this.classNameIn = this._setClassName(this.fare.FlightSectors[0].TransformedType);
            this.classNameOut = this._setClassName(this.fare.FlightSectors[1].TransformedType);
            this.selectButtonLabel = this.resourceService.get('BRANDED_FARE_TYPES_BUTTON_SELECT');
            this.selectedButtonLabel = this.resourceService.get('BRANDED_FARE_TYPES_BUTTON_SELECTED');
        }

        public select() {
            this.onSelect(this.fare);
        }

        public getBaggage(sector: ekh.IFlightSector) {
            return sector.BaggageText;
        }

        public getCabinBaggage(sector: ekh.IFlightSector) {
            return sector.CabinBaggageText;
        }

        public getSeatsSelection(sector: ekh.IFlightSector) {
            return sector.SeatsSelectionText;
        }

        public getChauffeur(sector: ekh.IFlightSector) {
            return sector.ChauffeurText;
        }

        public getPriceDelta(): string {
            const dif = this.fare.BrandedFareTypeTotalPrice - this.selectedFareTotalPrice;
            if (Math.round(dif) === 0) {
                return '';
            }
            let sign = dif > 0 ? '+' : '';
            return `${sign}${this.$filter<any>('roundedCurrency')(dif, this.currency)}`;
        }

        public isRestrictedSeats(sector: ekh.IFlightSector) {
            return this.brandedFareTypesService.isRestrictedSeats(sector);
        }

        public getSeatsSelectionTooltipText() {
            return this.resourceService.get('BRANDED_FARE_TYPES_SEAT_RESTRICTED_TOOLTIP_TEXT');
        }

        private _setClassName(type: ekh.TransformedType) {
            switch (type) {
                case ekh.TransformedType.EconomySpecial:
                    return 'economy-special';
                case ekh.TransformedType.EconomySaver:
                    return 'economy-saver';
                case ekh.TransformedType.EconomyFlex:
                    return 'economy-flex';
                case ekh.TransformedType.EconomyFlexPlus:
                    return 'economy-flex-plus';
                case ekh.TransformedType.BusinessSpecial:
                    return 'business-special';
                case ekh.TransformedType.BusinessSaver:
                    return 'business-saver';
                case ekh.TransformedType.BusinessFlex:
                    return 'business-flex';
                case ekh.TransformedType.BusinessFlexPlus:
                    return 'business-flex-plus';
                case ekh.TransformedType.FirstSaver:
                    return 'first-saver';
                case ekh.TransformedType.FirstFlex:
                    return 'first-flex';
                case ekh.TransformedType.FirstFlexPlus:
                    return 'first-flex-plus';
                default:
                    return '';
            }
        }
    }

    angular
        .module('core')
        .directive('brandedFare', (): ng.IDirective => {
            return {
                restrict: 'E',
                controller: BrandedFare,
                controllerAs: 'bf',
                bindToController: {
                    isSelected: '=',
                    fare: '=',
                    onSelect: '&',
                    pieceConceptLegIn: '=',
                    pieceConceptLegOut: '=',
                    selectedFareTotalPrice: '=',
                    currency: '='
                },
                template: `
                <div ng-class="[bf.classNameIn]" class="in-flight">
                    <div class="property-label branded-fare-title">
                        <img src="/build/img/emiratesHolidays/brandedFareTypes/ic-plane-right-white.svg">
                        <span>{{::bf.fare.FlightSectors[0].BrandTitle}}</span>
                    </div>
                    <div class="property-names-container" ng-class="{'piece-concept': bf.pieceConceptLegIn}">
                        <div class="property-label baggage-label">{{::bf.getBaggage(bf.fare.FlightSectors[0])}}</div>
                        <div class="property-label">{{::bf.getCabinBaggage(bf.fare.FlightSectors[0])}}</div>
                        <div class="property-label"
                             ng-class="{'restricted-seats': bf.isRestrictedSeats(bf.fare.FlightSectors[0])}">
                            {{::bf.getSeatsSelection(bf.fare.FlightSectors[0])}}
                            <span tooltip="{{bf.getSeatsSelectionTooltipText()}}">
                                <img src="/build/img/emiratesHolidays/brandedFareTypes/ic-info.svg"/>
                                </span>
                        </div>
                        <div class="property-label chauffeur-label">
                            {{::bf.getChauffeur(bf.fare.FlightSectors[0])}}
                        </div>
                    </div>
                </div>
                <div ng-class="[bf.classNameOut]" class="out-flight">
                    <div class="property-label branded-fare-title">
                        <img src="/build/img/emiratesHolidays/brandedFareTypes/ic-plane-left-white.svg">
                        <span>{{::bf.fare.FlightSectors[1].BrandTitle}}</span>
                    </div>
                    <div class="property-names-container" ng-class="{'piece-concept': bf.pieceConceptLegOut}">
                        <div class="property-label baggage-label">{{::bf.getBaggage(bf.fare.FlightSectors[1])}}</div>
                        <div class="property-label">{{::bf.getCabinBaggage(bf.fare.FlightSectors[1])}}</div>
                        <div class="property-label"
                             ng-class="{'restricted-seats': bf.isRestrictedSeats(bf.fare.FlightSectors[1])}">
                            {{::bf.getSeatsSelection(bf.fare.FlightSectors[1])}}
                            <span tooltip="{{bf.getSeatsSelectionTooltipText()}}">
                                <img src="/build/img/emiratesHolidays/brandedFareTypes/ic-info.svg"/>
                                </span>
                        </div>
                        <div class="property-label chauffeur-label">
                            {{::bf.getChauffeur(bf.fare.FlightSectors[1])}}
                        </div>
                        <div class="property-label total-price-delta"><span>{{bf.getPriceDelta()}}</span></div>
                        <button ng-if="!bf.isSelected" class="bft-select" ng-click="bf.select()">
                            {{bf.selectButtonLabel}}
                        </button>
                        <button ng-if="bf.isSelected" class="bft-select">{{bf.selectedButtonLabel}}</button>
                    </div>
                </div>

                `
            };
        });
}
